'use client';

import { NextPage } from 'next';
import { useForm } from 'react-hook-form';
import { Checkbox } from './CheckBox';
import Button from './Button';
import { useEffect, useState } from 'react';
import { shallow } from 'zustand/shallow';
import useOnboardingFormStore from '../../dashboard/stores/useOnboardingFormStore';
import { OnboardingFormComponentProps, UserAttributesType, goals } from '../utils/types';
import { useRouter } from 'next/navigation';

export const initialGoalsData = goals.reduce((acc, rec) => {
    return { ...acc, [rec.title]: false }
},{});

const Goals: NextPage<OnboardingFormComponentProps> = ({ currentStep, setCurrentStep, submitedForms, setSubmitedForms }) => {

    const router = useRouter();

    const [loading, setLoading] = useState<boolean>(false)

    const [steps, setCurrentStepToStore, updateUserRolesAndGoalsData, userOnboarding, optimizeSteps, setCurrentOptimizeStepToStore] = useOnboardingFormStore((state) => [state.steps, state.setCurrentStepToStore, state.updateUserRolesAndGoalsData, state.user, state.optimizeSteps, state.setCurrentOptimizeStepToStore], shallow);

    const { register, handleSubmit, getValues, watch } = useForm<{[key: string]: boolean}>({ defaultValues: optimizeSteps[currentStep] ? optimizeSteps[currentStep].data : {} });

    const formValues = Object.values(getValues()).length !== 0;

    const [values, setValues] = useState<boolean[]>((formValues && Object.values(getValues()).filter((value) => value)) || []);

    useEffect(() => {
        const subscription = watch((value) => setValues(Object.values(value).filter((value) => value) as boolean[]));
        return () => subscription.unsubscribe();
    }, [watch]);

    const onSubmit = (data: any) => {
        setLoading(true);
        setSubmitedForms([...submitedForms, currentStep]);
        setCurrentOptimizeStepToStore({ id: currentStep, data, isSubmited: true });
        updateUserRolesAndGoalsData({ type: UserAttributesType.GOALS, data });
        router.push('/dashboard?view=home&type=thank-you-optimize');
    };
    return (
        <form className="flex flex-col gap-4" onSubmit={handleSubmit(onSubmit)}>
            <h1 className="text-kartiv-gray-900 text-2xl font-semibold">
                What are your goals? <br /> Choose up to 3 goals.
            </h1>
            <div className="w-full grid gap-4 grid-cols-1">
                {goals.map((role) => {
                    return (
                        <div key={role.title}>
                            <Checkbox register={register} name={role.title} type="goals" />
                        </div>
                    );
                })}
            </div>
            <div className="pt-4">
                <Button disabled={!values || values.length < 1 || values.length > 3 || loading} label="Next" type="submit" isArrow loading={loading}/>
            </div>
        </form>
    );
};

export default Goals;